import { render } from "./MyCardFooter.vue?vue&type=template&id=55252a4e"
import script from "./MyCardFooter.vue?vue&type=script&lang=js"
export * from "./MyCardFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__